export default {
  MuiListItem: {
    root: {
      "&.Mui-selected": {
        backgroundColor: "inherit",
      },
    },
  },
};
